import axios from 'axios';
function stripString(string) {
        
         const numericValue = parseInt(string.replace(/,/g, ""), 10);
      
         return numericValue;
}
   

export const fetchHashrateData = async () => {
  try {
    // Fetch SHA3x hashrate data
    //const responseSha3x = await axios.get('https://api.taritracker.com/chain?algo=sha3x');
    //const sha_hashes = responseSha3x.data?.[0]?.target_difficulty;
    //if (sha_hashes === undefined) throw new Error('Invalid SHA3x data received');
    //const sha3x_hashrate = ((sha_hashes / 20) * Math.pow(10, -9)).toFixed(2);
    //const sha3x_hashrate = 0
    
    // Fetch RandomX hashrate data
    //const responseRandx = await axios.get('https://api.taritracker.com/chain?algo=randomx');
    //const randx_hashes = responseRandx.data?.[0]?.target_difficulty;
    //if (randx_hashes === undefined) throw new Error('Invalid RandomX data received');
    //const randx_hashrate = ((randx_hashes / 30) * Math.pow(10, -6)).toFixed(2);
    const randx_hashrate = 0
  
    // Fetch tip and network stats
    const responseTariBlockExplorer = await axios.get("https://textexplore.tari.com/?&json", { timeout: 15000 });
    if (!responseTariBlockExplorer.data?.tipInfo?.metadata?.best_block_height) 
      throw new Error('Invalid block explorer data received');
      
    const tip = responseTariBlockExplorer.data.tipInfo.metadata.best_block_height;
    //console.log(tip);
    
    
    const network_randx = ((responseTariBlockExplorer.data?.currentMoneroRandomxHashRate) * Math.pow(10, -9)).toFixed(2);
    const network_sha = ((responseTariBlockExplorer.data?.currentSha3xHashRate) * Math.pow(10, -12)).toFixed(2);
    const network_randxt = ((responseTariBlockExplorer.data?.currentTariRandomxHashRate) * Math.pow(10, -6)).toFixed(2);
    // The explorer reports graphs/second. Display kilographs/second (kGPS),
    // matching its own kg/s display rather than the million-fold hash scaling.
    const raw_cuckaroo = responseTariBlockExplorer.data?.currentCuckarooHashRate;
    const network_cuckaroo = raw_cuckaroo != null && raw_cuckaroo !== '' && Number.isFinite(Number(raw_cuckaroo)) && Number(raw_cuckaroo) >= 0
      ? (Number(raw_cuckaroo) / 1000).toFixed(2)
      : null;

    
 
    const hard_fork = Math.max(0, 95000 - parseInt(tip));
    const fork_est = hard_fork * 2;
    
    // Prepare the sidechain data object
    /*const sidechain_data = {
      "hashrate_sha3x": 0,
      "hashrate_randx": 0,
      "tip": parseInt(tip),
      "network_sha": network_sha,
      "network_randx": network_randx,
      "network_randxt": network_randxt,
      "hard_fork": hard_fork,
      "est": fork_est
    };
  */

     const sidechain_data = {
      "hashrate_sha3x": 0,
      "hashrate_randx": 0,
      "tip": parseInt(tip),
      "network_sha": network_sha,
      "network_randx": network_randx,
      "network_randxt": network_randxt,
      "network_cuckaroo": network_cuckaroo,
      "hard_fork": hard_fork,
      "est": fork_est
    };

    //console.log(sidechain_data)

    return sidechain_data;
  
  } catch (error) {
    console.error('Error fetching hashrate data:', error);
    throw error; // Re-throw error to be handled by the component
  }
};


export const fetchMarketData = async () => {
  try {
    // Fetch XTM currency data from SafeTrade API
    const response = await axios.get('https://safe.trade/api/v2/trade/public/currencies/xtm', { timeout: 15000 });
    //console.log(response.data);
    if (!response.data) throw new Error('Invalid market data received');
    return response.data;

  } catch (error) {
    console.error('Error fetching SafeTrade market data:', error.message || error);
    throw error; // Re-throw the error to allow handling upstream
  }
};

export const fetchGitHubPRs = async () => {
  const repos = ['tari', 'tari-dan', 'tari-universe'];
  const prPromises = repos.map(repo =>
    axios.get(`https://api.github.com/repos/tari-project/${repo}/pulls?state=open&per_page=5&sort=updated`, { timeout: 15000 })
      .then(res => res.data.map(pr => ({ ...pr, repoName: repo })))
      .catch(() => [])
  );
  const allPRs = (await Promise.all(prPromises))
    .flat()
    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
    .slice(0, 12);
  return allPRs;
};

export const fetchOotleSummary = async () => {
  const response = await axios.get('https://ootle.tari.com/llms.txt', { timeout: 15000 });
  return response.data;
};
